import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
import { vehicleBusinessStateTypeEnum, } from './vehicle.js';
/**
 * 合同“下一步”任务类型会写入工作流上下文，只能追加，不能改写既有值。
 */
export const contractNextStepTaskTypeEnum = createEnum({
    EXPORT_LICENSE: ['export-license', '许可证任务', 'gold'],
    CUSTOMS_DECLARATION: ['customs-declaration', '报关任务', 'blue'],
    VEHICLE_OUTBOUND: ['vehicle-outbound', '车辆出库任务', 'cyan'],
    INTERNATIONAL_LOGISTICS: [
        'international-logistics',
        '国际物流任务',
        'purple',
    ],
    VEHICLE_DELIVERY: ['vehicle-delivery', '车辆交付任务', 'green'],
    VEHICLE_CANCELLATION: ['vehicle-cancellation', '车辆注销任务', 'orange'],
    TAX_REFUND: ['tax-refund', '车辆退税任务', 'magenta'],
    PICKUP_INSPECTION: ['pickup-inspection', '提车验车任务', 'lime'],
    DOMESTIC_LOGISTICS: ['domestic-logistics', '国内物流任务', 'geekblue'],
});
export const CONTRACT_NEXT_STEP_TASK_TYPES = enumValues(contractNextStepTaskTypeEnum);
export const CONTRACT_NEXT_STEP_TASK_TYPE_LABEL_MAP = enumLabelMap(contractNextStepTaskTypeEnum);
/** 合同下一步任务与车辆主档业务状态维度的唯一映射。 */
export const CONTRACT_NEXT_STEP_BUSINESS_STATE_TYPE_MAP = {
    [contractNextStepTaskTypeEnum.EXPORT_LICENSE]: vehicleBusinessStateTypeEnum.EXPORT_LICENSE,
    [contractNextStepTaskTypeEnum.CUSTOMS_DECLARATION]: vehicleBusinessStateTypeEnum.CUSTOMS_DECLARATION,
    [contractNextStepTaskTypeEnum.VEHICLE_OUTBOUND]: vehicleBusinessStateTypeEnum.VEHICLE_OUTBOUND,
    [contractNextStepTaskTypeEnum.INTERNATIONAL_LOGISTICS]: vehicleBusinessStateTypeEnum.INTERNATIONAL_LOGISTICS,
    [contractNextStepTaskTypeEnum.VEHICLE_DELIVERY]: vehicleBusinessStateTypeEnum.VEHICLE_DELIVERY,
    [contractNextStepTaskTypeEnum.VEHICLE_CANCELLATION]: vehicleBusinessStateTypeEnum.VEHICLE_CANCELLATION,
    [contractNextStepTaskTypeEnum.TAX_REFUND]: vehicleBusinessStateTypeEnum.TAX_REFUND,
    [contractNextStepTaskTypeEnum.PICKUP_INSPECTION]: vehicleBusinessStateTypeEnum.PICKUP_INSPECTION,
    [contractNextStepTaskTypeEnum.DOMESTIC_LOGISTICS]: vehicleBusinessStateTypeEnum.DOMESTIC_LOGISTICS,
};
export function getContractNextStepBusinessStateType(taskType) {
    return CONTRACT_NEXT_STEP_BUSINESS_STATE_TYPE_MAP[taskType];
}
//# sourceMappingURL=contract-next-step.js.map